export const CampaignProductScope = {
  parent: 'Campaign',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Campaign Product Scope',
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    ProductCondition1: {
      'bulk-upload-header': 'Product Condition 1',
    },
    ProductCondition2: {
      'bulk-upload-header': 'Product Condition 2',
    },
    ProductCondition3: {
      'bulk-upload-header': 'Product Condition 3',
    },
    ProductCondition4: {
      'bulk-upload-header': 'Product Condition 4',
    },
    ProductCondition5: {
      'bulk-upload-header': 'Product Condition 5',
    },
    ProductCondition6: {
      'bulk-upload-header': 'Product Condition 6',
    },
    ProductCondition7: {
      'bulk-upload-header': 'Product Condition 7',
    },
    ProductValue1: {
      'bulk-upload-header': 'Product Value 1',
    },
    ProductValue2: {
      'bulk-upload-header': 'Product Value 2',
    },
    ProductValue3: {
      'bulk-upload-header': 'Product Value 3',
    },
    ProductValue4: {
      'bulk-upload-header': 'Product Value 4',
    },
    ProductValue5: {
      'bulk-upload-header': 'Product Value 5',
    },
    ProductValue6: {
      'bulk-upload-header': 'Product Value 6',
    },
    ProductValue7: {
      'bulk-upload-header': 'Product Value 7',
    },
    ProductOperator1: {
      'bulk-upload-header': 'Product Operator 1',
    },
    ProductOperator2: {
      'bulk-upload-header': 'Product Operator 2',
    },
    ProductOperator3: {
      'bulk-upload-header': 'Product Operator 3',
    },
    ProductOperator4: {
      'bulk-upload-header': 'Product Operator 4',
    },
    ProductOperator5: {
      'bulk-upload-header': 'Product Operator 5',
    },
    ProductOperator6: {
      'bulk-upload-header': 'Product Operator 6',
    },
    ProductOperator7: {
      'bulk-upload-header': 'Product Operator 7',
    },
  },
};
